import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, Container, Typography, Card } from "@mui/material";
// import details from "../../mocks/details";
import {
  parseCurrency,
  parseDate,
  parseTime,
} from "../../utils/tableFunctions";
import { getChargebackDetails } from "../../services/reconciliations";
import ReconDetailsHeader from "./ReconDetailsHeader";
import { Box } from "@mui/system";
import CircularLoader from "../../components/circularLoader";

const ChargebackDetails = () => {
  const [details, setDetails] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [refs, setRefs] = useState([]);

  const { id } = useParams();
  useEffect(() => {
    if (!loaded) {
      getChargebackDetails(id, setDetails, setRefs, setLoaded);
    }
  }, [id, loaded]);

  const renderReconciledCard = (detail) => {
    return (
      <>
        <Card sx={{ p: 3 }}>
          <Grid
            container
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 2, sm: 2, md: 2 }}
            sx={{ mt: 5 }}
          >
            <Grid item xs={6} md={6}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">Transaction ID</Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={7}
                  sx={{
                    overflowWrap: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {detail?.transaction?.id}
                </Grid>
                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">Terminal ID</Typography>
                </Grid>
                <Grid item xs={6} md={7}>
                  {detail?.terminal?.terminal_id}
                </Grid>
                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">Transaction Date</Typography>
                </Grid>
                <Grid item xs={6} md={7}>
                  {`${parseDate(detail.transaction_datetime)} ${parseTime(
                    detail.transaction_datetime
                  )}`}
                </Grid>

                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">
                    Acquirer Request Amount
                  </Typography>
                </Grid>
                <Grid item xs={6} md={7}>
                  {detail.acquirer_request_currency &&
                    `${detail.acquirer_request_currency} ${parseCurrency(
                      detail.acquirer_request_amount
                    )}`}
                </Grid>

                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">Acquirer Status</Typography>
                </Grid>
                <Grid item xs={6} md={7}>
                  {detail.acquirer_status}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} md={6}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">Card Number</Typography>
                </Grid>
                <Grid item xs={4} md={7}>
                  {detail.card_number === "nan" ? "" : detail.card_number}
                </Grid>
                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">
                    Reference Number
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={7}
                  sx={{
                    overflowWrap: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {detail.reference_number}
                </Grid>
                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">
                    Request Amount
                  </Typography>
                </Grid>
                <Grid item xs={4} md={7}>
                  {`${detail.transaction_currency} ${parseCurrency(
                    detail.transaction_amount
                  )}`}
                </Grid>

                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">Status</Typography>
                </Grid>
                <Grid item xs={4} md={7}>
                  {detail.transaction_state?.transaction_state}
                </Grid>
                <Grid item xs={6} md={5}>
                  <Typography variant="subtitle1">
                    Transaction Type
                  </Typography>
                </Grid>
                <Grid item xs={4} md={7}>
                  {detail.transaction_type?.transaction_type}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
        <Box sx={{ height: 30 }} />
      </>
    );
  };

  return (
    <>
      <Container>
        {loaded ? (
          <>
            <ReconDetailsHeader
              loaded={loaded}
              title="Chargeback Details"
              details={details}
              isChargeback={true}
            />
            {renderReconciledCard(details)}

            {loaded &&
              refs.length > 1 &&
              refs.slice(1).map((trans) => {
                return renderReconciledCard(trans);
              })}
          </>
        ) : (
          <CircularLoader />
        )}
      </Container>
    </>
  );
};

export default ChargebackDetails;
